<script>
const sidebarMenu = [
  // { path: '/', icon: 'fa fa-th', title: 'Home' },

  //Highlight
  { path: '/dashboard/highlight', icon: 'far fa-th-large mr-3', title: 'Highlight'},

  //Plan ALokasi
  { path: '/dashboard/plan-alokasi', icon: 'fal fa-clipboard-list-check mr-3', title: 'Plan Alokasi', type: "ADMIN_EKSPEDISI" },

  //Plan ALokasi Muat
  { path: '/dashboard/plan-alokasi-muat', icon: 'fal fa-clipboard-list-check mr-3', title: 'Alokasi Muat', type: "ADMIN_MAINDEALER" },

  //Register Muat
  { path: '/dashboard/register-muat', icon: 'far fa-truck-loading mr-3', title: 'Register Muat' },

  //Approval Bongkar
  { path: '/dashboard/bongkar-muat', icon: 'far fa-truck-ramp mr-3', title: 'Approval Bongkar' },

  //Service Rate
  { path: '/dashboard/service-rate', icon: 'far fa-boxes mr-3', title: 'Service Rate' },

  //Leadtime
  { path: '/dashboard/leadtime', icon: 'far fa-hourglass mr-3', title: 'Leadtime' },

  //Defect
  { path: '/dashboard/defect', icon: 'far fa-exclamation-triangle mr-3', title: 'Defect' },

  //NOS
  { path: '/dashboard/nos', icon: 'far fa-star mr-3', title: 'NOS', type: "ADMIN_MAINDEALER" },

  //Truck List
  { path: '/dashboard/truck-list', icon: 'far fa-truck mr-3', title: 'Truck List' },

  //Driver List
  { path: '/dashboard/driver-list', icon: 'far fa-user mr-3', title: 'Driver List' },

  //Activities
  // { path: '/dashboard/customer-activities', icon: 'far fa-chart-bar', title: 'Customer Activities' },

  //Consumer Insights
  // { path: '/dashboard/consumer-insights', icon: 'far fa-users', title: 'Consumer Insight' },

  //Reports
  // { path: '/dashboard/reports', icon: 'far fa-file-alt', title: 'Reports',
  //   children: [
  //     { path: '/dashboard/reports/customer', title: 'Report Customer' },
  //     { path: '/dashboard/reports/label-maker', title: 'Report Label Maker' },
  //     { path: '/dashboard/reports/oil-maker', title: 'Report Oil Maker' },
  //     { path: '/dashboard/reports/suspect', title: 'Report Suspect' },
  //     { path: '/dashboard/reports/qrcode', title: 'QR Code' },
  //   ]
  // },

  //Settings
  { path: '/dashboard/settings/user-management', icon: 'far fa-cog mr-3', title: 'User Management', 
        children : [
          { path: '/dashboard/settings/user-management/dashboard-user', title: 'User Settings' },
          { path: '/dashboard/settings/user-management/add-plant', title: 'Add Plant', type: "ADMIN_MAINDEALER"  },
          { path: '/dashboard/settings/holiday', title: 'Holiday', type: "ADMIN_MAINDEALER"  },
          { path: '/dashboard/settings/leadtime-settings', title: 'Leadtime Settings', type: "ADMIN_MAINDEALER" },
          { path: '/dashboard/settings/gudang', title: 'Gudang', type: "ADMIN_MAINDEALER" }
          // { path: '/dashboard/settings/user-management/penindakan-app', title: 'Penindakan App' },
        ]
      },

  //CSO
  // { path: '/cso', icon: 'fas fa-table', title: 'CSO',
  //   children: [
  //     { path: '/cso/exit-permit', title: 'Gatepass' },
  //     { path: '/cso/customer-quotation', title: 'Quotation' },
  //     { path: '/cso/insurance-policy', title: 'Insurance Policy' },
  //     { path: '/cso/master-data', title: 'Master Data',
  //       children: [
  //         { path: '/cso/master-data/color', title: 'Warna Mobil' },
  //         { path: '/cso/master-data/brand-&-type', title: 'Merk Dan Tipe Mobil' },
  //         { path: '/cso/master-data/customer', title: 'Pelanggan' },
  //         { path: '/cso/master-data/customer-car', title: 'Mobil Pelanggan' },
  //         { path: '/cso/master-data/laborer', title: 'Pekerja' },
  //         { path: '/cso/master-data/supplier', title: 'Supplier' },
  //       ]
  //     },
  //   ]
  // },
]

export default sidebarMenu;
</script>
